export default __webpack_public_path__ + "static/media/costco-eggs.8c166076.png";